import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetAllBankAccount(isUseMainDatabase = false) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetAllBankAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllBankAccountForInvestigate() {
    let _input = {};
    return API.peakAPI
      .post("/api/Finance/GetAllbankAccountForInvestigate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentTransactionForInvestigateById(peakPaymentIdList) {
    let _input = {
      peakPaymentIdList: peakPaymentIdList,
    };
    return API.peakAPI
      .post("/api/Finance/GetPaymentTransactionById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringFinance() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
    };
    return API.peakReportAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetMerchantMonitoringFinance(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/SetMerchantMonitoringFinance", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringFinanceByFinanceIdList(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/GetMerchantMonitoringFinanceByFinanceIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetUnreceivedCheque(type) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: type,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetUnreceivedCheque", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoInsertBankAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccount: input.bankAccount,
      isAllowDupplicateBankAccountNumber: input.isAllowDupplicateBankAccountNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/CreateBankAccountOnce", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoEditBankAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccount: input.bankAccount,
      isAllowDupplicateBankAccountNumber: input.isAllowDupplicateBankAccountNumber,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/EditBankAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCurrencyExchangeRatesByDate(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: input.date.ToDateJsonString(),
      currencyCode: input.currencyCode,
    };
    return API.peakAPI
      .post("/api/Finance/GetCurrencyExchangeRatesByDate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetEwalletProvider() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetEwalletProvider", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestBankAccountCode() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetSuggestBankAccountCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankReferenceList(language) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: language,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetBankReference", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllCheque() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI.post("/api/Finance/GetAllCheque", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeDetail(chequeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeId: chequeId,
    };
    return API.peakRealTimeAPI.post("/api/Finance/GetChequeDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateFavoriteBankaccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: input.bankAccountId,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
    };
    return API.peakAPI
      .post("/api/Finance/UpdateFavoriteBankaccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteFavoriteBankaccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: input.bankAccountId,
      paymentInOutFlowTypeId: input.paymentInOutFlowTypeId,
    };
    return API.peakAPI
      .post("/api/Finance/DeleteFavoriteBankaccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFavoriteBankaccount(paymentInOutFlowTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      paymentInOutFlowTypeId: paymentInOutFlowTypeId,
    };
    return API.peakAPI.post("/api/Finance/GetFavoriteBankaccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoUpdateReceivedWht(input) {
    const _input = {
      whtId: input.whtId,
      isReceivedWHT: input.isReceivedWht,
      registerWht: input.registerWht,
      paymentInOutFlowType: input.paymentInOutFlowType,
      eWhtType: input.eWhtType,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/UpdateIsReceivedWht", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankAccountDetailByBankAccountId(bankAccountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      bankAccountId: bankAccountId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetBankAccountListByBankAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoTransferPayment(transferPayment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      transferPayment: transferPayment,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/TransferPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidTransferPayment(peakPaymentId) {
    let _input = {
      peakPaymentId: peakPaymentId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Payment/VoidTransferPayment", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeletePaymentBankStatement(input) {
    const _input = {
      id: input.id,
      bankAccountId: input.bankAccountId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PaymentBankStatement/DeletePaymentBankStatement", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceCalendarDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      month: input.month,
      year: input.year,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceCalendarFutureDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      month: input.month,
      year: input.year,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarFutureDashboard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceCalendarDashboardDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: input.date,
      currentDate: input.currentDate,
    };
    return API.peakAPI
      .post("/api/Dashboard/GetFinanceCalendarDashboardDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetFinanceChequeDashboard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakAPI
      .post("/api/Dashboard/GetChequeDashboardSummary", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateChequeDetail(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      cheque: {
        accountNumber: input.accountNumber,
        branchNumber: input.branchNumber,
        id: input.id,
        chequeNumber: input.chequeNumber,
        bankAccountId: input.bankAccountId,
        bankReferenceId: input.bankReferenceId,
        chequeDate: input.chequeDate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/UpdateChequeDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateReceivedAndClearingCheque(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      cheque: {
        id: input.id,
        isReceived: input.isReceived,
        bankAccountId: input.bankAccountId,
        recieveDate: input.recieveDate,
      },
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/Finance/UpdateReceivedAndClearingCheque", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRegisterWithheldtax(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      whtId: input.whtId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRegisterWithheldtaxFromCustomer", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteCheque(searchText) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchText: searchText,
    };
    return API.peakAPI.post("/api/Finance/GetAutoCompleteCheque", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeByIdList(chequeIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeIdList: chequeIdList,
    };
    return API.peakAPI.post("/api/Finance/GetChequeByIdList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetChequeByCodeList(chequeCodeList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      chequeCodeList: chequeCodeList,
    };
    return API.peakAPI.post("/api/Finance/GetChequeByCodeList", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreatePaymentBankStatement(bankStatementsList, createType) {
    const input = {
      paymentBankStatementList: bankStatementsList,
      createType: createType,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/PaymentBankStatement/CreatePaymentBankStatement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidBankReconciled(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      reconciledGroupId: input.reconciledGroupId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BankReconciled/VoidBankReconciled", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReconcileBankStatement(_input) {
    const input = {
      bankAccountId: _input.bankAccountId,
      isApproved: _input.isApproved,
      paymentTransactionIdList: _input.paymentTransactionIdList,
      bankStatementIdList: _input.bankStatementIdList,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/BankReconciled/ReconcileBankStatement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoApproveBankReconciled(input) {
    const _input = {
      bankAccountId: input.bankAccountId,
      reconciledGroupId: input.reconciledGroupId,
    };
    return API.peakRealTimeAPIForTransaction
      .post("/api/BankReconciled/ApproveBankReconciled", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRemarkPeakPayment(peakPaymentId) {
    const input = {
      peakPaymentId: peakPaymentId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRemarkPeakPayment", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetRemarkPaymentStatement(paymentStatementId) {
    const input = {
      paymentStatementId: paymentStatementId,
    };
    return API.peakRealTimeAPI
      .post("/api/Finance/GetRemarkPaymentStatement", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetPaymentMethodCount() {
    const headers = userInfo.SetHeaderService().headers;
    return API.peakRealTimeAPI.get("/api/finance/GetPaymentMethodCount", { headers }).then((res) => {
      return res;
    });
  },
  DoReInsertJournalItemBankAccountNotMatchPayment(journalItemPaymentList) {
    const input = {
      journalItemPaymentList: journalItemPaymentList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Payment/ReInsertJournalItemBankAccountNotMatchPayment", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReInsertJournalItemBankAccountNotHavePayment(journalItemIdList) {
    const input = {
      journalItemIdList: journalItemIdList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Payment/ReInsertJournalItemBankAccountNotHavePayment", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoVoidPaymentNotReferenceJournalItem(peakPaymentIdList) {
    const input = {
      peakPaymentIdList: peakPaymentIdList,
    };
    return API.peakRealTimeAPIForImport
      .post("/api/Payment/VoidPaymentNotReferenceJournalItem", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetContactStatementRemarkFrequencyCountByBankTypeId(bankReferenceBankType) {
    const input = {
      bankReferenceBankType: bankReferenceBankType,
    };
    return API.peakAPI
      .post(
        "/api/BankReconciled/GetContactStatementRemarkFrequencyCountByBankTypeId",
        input,
        userInfo.SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  },
  DoGetContactStatementRemarkFrequencyByBankTypeId(_input) {
    const input = {
      bankReferenceBankType: _input.bankReferenceBankType,
      pageNumber: _input.pageNo,
      pageSize: _input.pageSize,
    };
    return API.peakAPI
      .post("/api/BankReconciled/GetContactStatementRemarkFrequencyByBankTypeId", input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBankAccountViewDetail(_input) {
    const input = {
      bankAccountIds: _input,
    };
    return API.peakAPI.post("/api/Finance/GetBankAccountViewDetail", input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
};
